export default __webpack_public_path__ + "static/media/404_error.07418191.svg";